import { axiosApiInstance } from '@/api/axios'

const state = {
  loading: false,
  products: [],
  productBasicInfo: {},
  productGallery: [],
  productFeatures: [],
  productChars: {},
  productDesc: {},
  productCategory: {},
  productCategories: []
}

const getters = {
  productsPageLoading: (state) => state.loading,
  products: (state) => state.products,
  productBasicInfo: (state) => state.productBasicInfo,
  productGallery: (state) => state.productGallery,
  productFeatures: (state) => state.productFeatures,
  productChars: (state) => state.productChars,
  productDesc: (state) => state.productDesc,
  productCategory: (state) => state.productCategory,
  productCategories: (state) => state.productCategories
}

const mutations = {
  setProductsPageLoading(state, payload) {
    state.loading = payload
  },
  setProductBasicInfo(state, payload) {
    state.productBasicInfo = payload
  },
  setProducts(state, payload) {
    state.products = payload
  },
  setProductGallery(state, payload) {
    state.productGallery = payload
  },
  setProductFeatures(state, payload) {
    state.productFeatures = payload
  },
  setProductChars(state, payload) {
    state.productChars = payload
  },
  setProductDesc(state, payload) {
    state.productDesc = payload
  },
  setProductCategory(state, payload) {
    state.productCategory = payload
  },
  SET_PRODUCT_CATEGORIES(state, payload) {
    state.productCategories = payload
  }
}

const actions = {
  fetchProducts({ commit }, { vm }) {
    commit('setProductsPageLoading', true)
    axiosApiInstance
      .get(vm.apiUrl)
      .then((res) => {
        if (res.status === 200) {
          vm.numberOfPages = res.data.last_page
          vm.page = res.data.current_page
          commit('setProducts', res.data.data)
        }
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          commit('setProductsPageLoading', false)
        }, 1000)
      })
  },

  fetchProductWithSlug({ commit }, payload) {
    commit('setProductsPageLoading', true)
    axiosApiInstance
      .get('/api/public/get_product_with_slug', {
        params: {
          slug: payload
        }
      })
      .then((res) => {
        commit('setProductBasicInfo', {
          id: res.data.id,
          name: res.data.name,
          price: res.data.price,
          oldPrice: res.data.old_price
        })
        commit('setProductGallery', res.data.gallery)
        commit('setProductFeatures', res.data.features)
        commit('setProductChars', {
          character_en: res.data.character_en,
          character_ru: res.data.character_ru,
          character_uz: res.data.character_uz
        })
        commit('setProductDesc', {
          description_en: res.data.description_en,
          description_ru: res.data.description_ru,
          description_uz: res.data.description_uz
        })

        commit('setProductCategory', res.data.category)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        commit('setProductsPageLoading', false)
      })
  },

  fetchCategoriesForProducts({ commit }) {
    axiosApiInstance
      .get('/api/public/get_product_categories')
      .then((res) => {
        commit('SET_PRODUCT_CATEGORIES', res.data)
      })
      .catch((err) => console.log(err))
  },

  clearProductWithSlug({ commit }) {
    commit('setProductsPageLoading', false)
    commit('setProductGallery', [])
    commit('setProductFeatures', [])
    commit('setProductChars', {})
    commit('setProductDesc', {})
    commit('setProductCategory', {})
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
